import React from 'react'
import Firebase from 'firebase'

import { getDocsFromQuery } from './db_util'
import Loading from '../views/misc/Loading'
import Error from '../views/misc/Error'

const withPlayerGames = (WrappedComponent) => {

  class componentWithPlayerGames extends React.Component {

    constructor(props) {
      super(props)
      this.state = {
        loading: true,
        error: null,
        players: null,
      }
    }

    componentWillMount() {
      this._subscribeToPlayerChanges()
    }

    componentWillReceiveProps() {
      this._subscribeToPlayerChanges()
    }

    _subscribeToPlayerChanges = () => {
      if (this.unsubscribe) {
        this.unsubscribe()
      }
      this.unsubscribe = Firebase.firestore().collection('players').where('user', '==', this.props.userId).onSnapshot( docs => {
        let players = getDocsFromQuery(docs)
        this.setState({
          loading: false,
          error: null,
          players,
        })
      }, error => {
        this.setState({
          loading: false,
          error,
          players: null,
        })
      })
    }

    componentWillUnmount() {
      this.unsubscribe()
    }

    render() {

      if (this.state.error) {
        return <Error />
      }

      if (this.state.loading) {
        return <Loading />
      }

      const players = this.state.players.sort( (a, b) => new Date(a.joinedAt) < new Date(b.joinedAt) )
      // debugger
      return <WrappedComponent
        {...this.props}
        players={players}
        />
    }
  }
  componentWithPlayerGames.displayName = `withPlayerGames(${WrappedComponent.name})`;
  return componentWithPlayerGames
}

export default withPlayerGames



// WEBPACK FOOTER //
// ./src/data/withPlayerGames.jsx